/**
 * Fades its content up once, the first time it scrolls into view.
 *
 * Content is visible until this module defines the element, so pages without
 * JavaScript, or with the theme setting off, show everything immediately.
 * Elements already in view when they connect (first paint or a theme editor
 * re-render) are revealed without animating. Reduced-motion is handled in CSS.
 */
class SnaplokReveal extends HTMLElement {
  /** @type {IntersectionObserver | undefined} */
  static #observer;

  static get observer() {
    SnaplokReveal.#observer ??= new IntersectionObserver(
      (entries, observer) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          entry.target.setAttribute('revealed', '');
          observer.unobserve(entry.target);
        }
      },
      { rootMargin: '0px 0px -10% 0px' }
    );

    return SnaplokReveal.#observer;
  }

  connectedCallback() {
    if (this.hasAttribute('revealed')) return;

    if (this.getBoundingClientRect().top < window.innerHeight) {
      this.setAttribute('revealed', '');
      return;
    }

    SnaplokReveal.observer.observe(this);
  }

  disconnectedCallback() {
    SnaplokReveal.#observer?.unobserve(this);
  }
}

if (!customElements.get('snaplok-reveal')) {
  customElements.define('snaplok-reveal', SnaplokReveal);
}
